import styled from 'styled-components';
import { Button } from '@simplywallst/ui-core';

export const ToggleButton = styled(Button)<{ light?: boolean }>`
  padding: 0;
  white-space: nowrap;
  text-align: right;
  ${({ theme }) => theme.typography.tiny};
  color: ${({ theme, light }) =>
    light ? theme.color.spaceGrayRGBA(0.8) : theme.color.whiteRGBA(0.3)};
`;

export const ToggleLabel = styled('span')<{ light?: boolean }>`
  border-bottom: 1px solid
    ${({ theme, light }) =>
      light ? theme.color.lightGray : theme.color.whiteRGBA(0.3)};
`;
